<template>
  <div style="position: relative">
    <canvas style="width: 100%; display: block"></canvas>
    <div class="annotationLayer"></div>
    <resize-sensor @resize="resize"></resize-sensor>
  </div>
</template>

<script>
  import { PDFJSWrapper } from '../static/pdf'
  import resizeSensor from 'vue-resize-sensor'

  export default {
    name: 'ep-pdf',
    components: {
      'resize-sensor': resizeSensor,
    },
    props: {
      src: {
        type: [String, Object],
        default: '',
      },
      page: {
        // type: Number,
        default: 1,
      },
      rotate: {
        type: Number,
        default: 0,
      },
      password: {
        type: Function,
        default: null,
      },
    },
    watch: {
      src: function () {

        this.pdf.loadDocument(this.src);
      },
      page: function () {
        this.pdf.loadPage(this.page, this.rotate);
      },
      rotate: function () {

        this.pdf.renderPage(this.rotate);
      },
    },
    methods: {
      resize: function (size) {
        var canvasElt = this.$el.childNodes[0];
        var annotationLayerElt = this.$el.childNodes[2];

        // on IE10- canvas height must be set
        canvasElt.style.height = canvasElt.offsetWidth * (canvasElt.height / canvasElt.width) + 'px';

        // update the page when the resolution is too poor
        var resolutionScale = this.pdf.getResolutionScale();

        if (resolutionScale < 0.85 || resolutionScale > 1.15)
          this.pdf.renderPage(this.rotate);

        PDFJS.CustomStyle.setProp('transform', annotationLayerElt, 'scale(' + resolutionScale + ')');
      },
      print: function (dpi, pageList) {

        this.pdf.printPage(dpi, pageList);
      },
      reload() {
        this.pdf.loadDocument(this.src);
      }
    },
    mounted: function () {
      var canvasElt = this.$el.childNodes[0];
      var annotationLayerElt = this.$el.childNodes[2];

      this.pdf = new PDFJSWrapper(PDFJS, canvasElt, annotationLayerElt, this.$emit.bind(this));

      this.$on('loaded', function () {

        this.pdf.loadPage(this.page, this.rotate);
      });

      this.$on('pageSize', function (width, height) {

        canvasElt.style.height = canvasElt.offsetWidth * (height / width) + 'px';
      });

      this.pdf.loadDocument(this.src);
    },
    destroyed: function () {

      this.pdf.destroy();
    }
  }

</script>

<style scoped>
  /* @import url('../static/pdf.css'); */
</style>


// WEBPACK FOOTER //
// Pdf.vue?cbcd25dc